"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resolveShowIf;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));

var _micromatch = _interopRequireDefault(require("micromatch"));

// istanbul ignore next
var cond = function cond() {
  for (var _len = arguments.length, cnds = new Array(_len), _key = 0; _key < _len; _key++) {
    cnds[_key] = arguments[_key];
  }

  return function (v) {
    return (cnds.find(function (x) {
      return x[0](v);
    }) || [null, function () {
      return undefined;
    }])[1](v);
  };
};
/**
 *
 * We expect scope is `Array<string>`. Can include single strings like `admin`. Or strings separated
 *
 * @param {Object} showIfCtx
 * @param {Object} showIfCtx.user
 * @param {Array<string>} showIfCtx.scope
 * @param {boolean | string | function} showIf Boolean nebo scope pattern.
 *
 * @returns {boolean}
 */


function resolveShowIf(showIfCtx, showIf) {
  (0, _tinyInvariant.default)(showIfCtx && (0, _typeof2.default)(showIfCtx) === 'object', 'resolveShowIf() require showIfCtx as Object.');
  var _showIfCtx$isAdmin = showIfCtx.isAdmin,
      isAdmin = _showIfCtx$isAdmin === void 0 ? false : _showIfCtx$isAdmin,
      processScope = showIfCtx.processScope,
      _showIfCtx$scope = showIfCtx.scope,
      scope = _showIfCtx$scope === void 0 ? [''] : _showIfCtx$scope,
      rest = (0, _objectWithoutProperties2.default)(showIfCtx, ["isAdmin", "processScope", "scope"]);
  (0, _tinyInvariant.default)(Array.isArray(scope), 'resolveShowIf() showIfCtx.scope have to be an array.');
  var typeofShowIf = (0, _typeof2.default)(showIf);
  return cond([function ($showIf) {
    return scope.includes('') && $showIf !== 'anonymouse';
  }, function () {
    return false;
  }], [function ($showIf) {
    return $showIf === null || $showIf === undefined;
  }, function () {
    return false;
  }], [function () {
    return typeofShowIf === 'boolean';
  }, function (s) {
    return s;
  }], [function () {
    return typeofShowIf === 'function';
  }, function (s) {
    var r = s((0, _extends2.default)({}, rest, {
      isAdmin: isAdmin,
      scope: scope,
      processScope: processScope
    }));
    return typeof r === 'boolean' ? r : false;
  }], [function () {
    return typeofShowIf === 'string';
  }, function (s) {
    return cond([function (x) {
      return x === '';
    }, function () {
      return scope.length === 1 && scope[0] === '';
    }], [function () {
      return scope.includes('*');
    }, function () {
      return true;
    }], [function (x) {
      return x === 'isAdmin';
    }, function () {
      return isAdmin;
    }], [function () {
      return true;
    }, function (x) {
      var _ref = processScope(x),
          _ref2 = (0, _slicedToArray2.default)(_ref, 1),
          tgt = _ref2[0];

      var isMatching = scope.reduce(function (a, y) {
        return _micromatch.default.isMatch(y, tgt) ? [].concat((0, _toConsumableArray2.default)(a), [y]) : a;
      }, []);
      return isMatching.length === tgt.length;
    }])(s.trim());
  }], [// istanbul ignore next
  function () {
    return true;
  }, // istanbul ignore next
  function () {
    return false;
  }])(showIf);
}